import find from 'lodash/find';
import range from 'lodash/range';
export default (variables) => {
	const zeroYear = variable =>
		find(variables, ele => ele.name === variable && ele.year === 0);
	const variablesIds = {
		sales: [
			{ id: 'supposedPrice', type: 'number' },
			{ id: 'supposedDaysReceivable', type: 'number' },
			{ id: 'supposedMarketingExpenses', type: 'number' },
			{
				id: 'supplierBottleChoice',
				type: 'number',
				value: zeroYear('supplierBottleChoice')
			},
			{ id: 'supposedQuality', type: 'number' },
			{ id: 'supposedSoldUnits', type: 'number' },
			{ id: 'supposedDemandQuota', type: 'number' },
			{ id: 'price', type: 'array' },
			{ id: 'daysReceivable', type: 'array' },
			{ id: 'marketingExpenses', type: 'array' },
			{
				id: 'supplierBottleChoice',
				type: 'number',
				value: zeroYear('supplierBottleChoice')
			},
			{ id: 'quality', type: 'array' },
			{ id: 'soldUnits', type: 'array' },
			{ id: 'demandQuota', type: 'array' }
		],
		production: [
			{ id: 'soldUnits', type: 'array' },
			{ id: 'internallyProducedUnits', type: 'array' },
			{ id: 'outsourcedUnits', type: 'array' },
			{ id: 'producedUnits', type: 'array' },
			{ id: 'endingWhJuice', type: 'array' },
			{ id: 'machineProductionCapacity', type: 'array' },
			{ id: 'machines', type: 'number', value: zeroYear('machines') },
			{ id: 'totalProductionCapacityAtFullUsage', type: 'array' },
			{ id: 'machineProductionCapacityUsageQuota', type: 'array' },
			{ id: 'machineProductionCapacityUsage', type: 'array' },
			{ id: 'outsourcingQuota', type: 'array' },
			{ id: 'qualityCheckPersonel', type: 'array' },
			{ id: 'recyclingAndWasteManagement', type: 'array' },
			{ id: 'qualityMaintenance', type: 'array' },
			{ id: 'juiceTaster', type: 'array' },
			{ id: 'chemicalExpert', type: 'array' },
			{ id: 'machineCost', type: 'number', value: zeroYear('machineCost') },
			{
				id: 'machinesTotalCost',
				type: 'number',
				value: zeroYear('machinesTotalCost')
			},
			{ id: 'machineryDepreciation', type: 'array' },
			{ id: 'totalBuildings', type: 'array' },
			{ id: 'buildingRentUnit', type: 'array' },
			{ id: 'buildingRentTotal', type: 'array' },
			{ id: 'qualityCheckPersonelTotalCosts', type: 'array' },
			{ id: 'qualityCheckPersonelDepreciation', type: 'array' },
			{ id: 'recyclingAndWasteManagementTotalCosts', type: 'array' },
			{ id: 'qualityMaintenanceTotalCosts', type: 'array' },
			{ id: 'juiceTasterTotalCost', type: 'array' },
			{ id: 'chemicalExpertTotalCost', type: 'array' },
			{ id: 'qualityTotalCosts', type: 'array' }
		],
		procurement: [
			{ id: 'outsourcedProductionCosts', type: 'array' },
			{ id: 'outsourcingDaysPayable', type: 'array' },
			{ id: 'beginningWhBottles', type: 'array' },
			{ id: 'beginningWhApples', type: 'array' },
			{ id: 'supplierOrderBottles', type: 'array' },
			{ id: 'supplierOrderApples', type: 'array' },
			{ id: 'endingWhBottles', type: 'array' },
			{ id: 'endingWhApples', type: 'array' },
			{ id: 'supplyNeedsBottles', type: 'array' },
			{ id: 'supplyNeedsApples', type: 'array' },
			{
				id: 'supplierBottleChoice',
				type: 'number',
				value: zeroYear('supplierBottleChoice')
			},
			{
				id: 'supplierAppleChoice',
				type: 'number',
				value: zeroYear('supplierAppleChoice')
			},
			{
				id: 'MinimumLotApples',
				type: 'array',
				value: range(1, 4).map(n =>
					find(variables, ele => ele.name === `supplier${n}MinimumLotApples`)
				)
			},
			{
				id: 'CostApples',
				type: 'array',
				value: range(1, 4).map(n =>
					find(variables, ele => ele.name === `supplier${n}CostApples`)
				)
			},
			{
				id: 'daysInPayablesApples',
				type: 'array',
				value: range(1, 4).map(n =>
					find(
						variables,
						ele => ele.name === `supplier${n}daysInPayablesApples`
					)
				)
			}
		],
		incomeStatement: [
			{ id: 'revenues', type: 'array' },
			{ id: 'directMaterialCosts', type: 'array' },
			{ id: 'outsourcedProductionCosts', type: 'array' },
			{ id: 'sellingCommissions', type: 'array' },
			{ id: 'contributionMargin', type: 'array' },
			{ id: 'productionOverheads', type: 'array' },
			{ id: 'marketingExpenses', type: 'array' },
			{ id: 'sellingExpenses', type: 'array' },
			{ id: 'generalAndAdministrativeExpenses', type: 'array' },
			{ id: 'operatingIncome', type: 'array' },
			{ id: 'interestExpensesLongTerm', type: 'array' },
			{ id: 'interesetExpensesOnBankOverdraft', type: 'array' },
			{ id: 'preTaxIncomeWithShortTerm', type: 'array' },
			{ id: 'taxes', type: 'array' },
			{ id: 'netIncome', type: 'array' }
		],
		balanceSheet: [
			{ id: 'cash', type: 'array' },
			{ id: 'accountReceivables', type: 'array' },
			{ id: 'totalRawMaterialInventory', type: 'array' },
			{ id: 'finishedGoodsInventory', type: 'array' },
			{ id: 'totalCurrentAssets', type: 'array' },
			{ id: 'netFixedAssets', type: 'array' },
			{ id: 'totalAssets', type: 'array' },
			{ id: 'accountPayables', type: 'array' },
			{ id: 'shortTermDebts', type: 'array' },
			{ id: 'currentLiabilities', type: 'array' },
			{ id: 'longTermDebt', type: 'array' },
			{ id: 'totalLiabilities', type: 'array' },
			{ id: 'equity', type: 'array' },
			{ id: 'retainedEarnings', type: 'array' },
			{ id: 'netIncome', type: 'array' },
			{ id: 'totalEquity', type: 'array' },
			{ id: 'totalLiabilitiesAndEquity', type: 'array' },
			{ id: 'leverage', type: 'array' }
		],
		cashFlowStatement: [
			{ id: 'netIncome', type: 'array' },
			{ id: 'fixedAssetsDepreciation', type: 'array' },
			{ id: 'inventoryDelta', type: 'array' },
			{ id: 'receivablesDelta', type: 'array' },
			{ id: 'payablesDelta', type: 'array' },
			{ id: 'cashFlowFromOperations', type: 'array' },
			{ id: 'capitalExpenditures', type: 'array' },
			{ id: 'longTermDebtDelta', type: 'array' },
			{ id: 'shortTermDebtsDelta', type: 'array' },
			{ id: 'equityDelta', type: 'array' },
			{ id: 'totalCashFlow', type: 'array' }
		],
		results: [
			{ id: 'revenues', type: 'array' },
			{ id: 'operatingIncome', type: 'array' },
			{ id: 'cccSales', type: 'array' },
			{ id: 'cash', type: 'array' },
			{ id: 'leverage', type: 'array' },
			{ id: 'roe', type: 'array' },
			{ id: 'roa', type: 'array' }
		]
	};
	const sections = Object.keys(variablesIds);
	const data = {};
	sections.forEach(
		section =>
			(data[section] = variablesIds[section].reduce((acc, item) => {
				acc[item.id] = item.value
					? item.value
					: item.type === 'number'
						? find(variables, ele => ele.name === item.id && ele.year === 1)
						: range(1, 4).map(n =>
							find(variables, ele => ele.name === item.id && ele.year === n)
								  );
				if (!acc[item.id]) {
					console.log(
						`Can't query variable '${item.id}' with item value '${
							item.value
						}'`
					);
				}
				return acc;
			}, {}))
	);
	return data;
}
